import type { RiskBand, RiskBandSet, RiskRatingValues } from '@gcv/shared';
import { injectable } from 'inversify';

import { banksApi } from './api-util/api';

/** Sent in the request body. No status filter: band sets have no draft state. */
export interface RiskBandSetQuery {
  /** Versions to return, e.g. ['latest', '1']. Omit for the active 'latest' only. */
  versions?: string[];
  /** When true, return only the most-recently-updated version of each logical band set. */
  last_updated_only?: boolean;
}

/** Scoreable immediately, so the cutoffs and values are required up front. */
export interface CreateRiskBandSetPayload {
  name: string;
  description?: string;
  bands: RiskBand[];
  rating_values: RiskRatingValues;
}

export interface UpdateRiskBandSetPayload {
  name: string;
  description?: string;
  bands: RiskBand[];
  rating_values: RiskRatingValues;
}

@injectable()
export class RiskBandsApi {
  async queryRiskBandSets(bankId: string, query?: RiskBandSetQuery): Promise<RiskBandSet[]> {
    return await banksApi().post(`/banks/${bankId}/risk-bands/query`, query ?? {});
  }

  async createRiskBandSet(bankId: string, data: CreateRiskBandSetPayload): Promise<RiskBandSet> {
    return await banksApi().post(`/banks/${bankId}/risk-bands`, data);
  }

  /** The edit lands on a new active version; the record it supersedes is archived. */
  async updateRiskBandSet(bankId: string, id: string, data: UpdateRiskBandSetPayload): Promise<RiskBandSet> {
    return await banksApi().put(`/banks/${bankId}/risk-bands/${id}`, data);
  }
}
